import { css } from 'lit';
         export default css` 
         @charset "UTF-8";
/* ------------------------------------*\
    #BREAKPOINT VARIABLES
\*------------------------------------ */
/* ------------------------------------*\
    #TYPOGRAPHY APPLICATIONS
\*------------------------------------ */
/**
   * Visible focus outline 2px inside the element on a light background
   */
/**
   * Visible focus outline 2px inside the element on a dark background
   */
/**
   * Visible focus outline for elements on a light background
   */
/**
   * Invisible focus outline for elements that need a more visible
   * focus state for high-contrast mode
   */
/**
   * Visually hidden from display
   */
/**
   * style for text ellipsis
   */
/**
   * Popover attribute has default styling which comes from UA stylesheets which will be overridden here.
   */
/* ------------------------------------*\
    #VISIBILITY UTILITIES
\*------------------------------------ */
/* Completely remove from the flow and screen readers. */
.cat-u-is-hidden {
  display: none !important;
  visibility: hidden !important;
}

/* Completely remove from the flow but leave available to screen readers. */
.cat-u-is-vishidden {
  position: absolute !important;
  overflow: hidden;
  width: 1px;
  height: 1px;
  padding: 0;
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
}

/**
 * Hide element at sm breakpoint 
 */
@media all and (min-width: 23.4375rem) {
  .cat-u-hide-sm {
    display: none !important;
  }
}

/**
 * Hide element at sm-2 breakpoint 
 */
@media all and (min-width: 35rem) {
  .cat-u-hide-sm-2 {
    display: none !important;
  }
}

/**
 * Hide element at md breakpoint 
 */
@media all and (min-width: 48rem) {
  .cat-u-hide-md {
    display: none !important;
  }
}

/**
 * Hide element at lg breakpoint 
 */
@media all and (min-width: 60rem) {
  .cat-u-hide-lg {
    display: none !important;
  }
}

/**
 * Hide element at xl breakpoint 
 */
@media all and (min-width: 75rem) {
  .cat-u-hide-xl {
    display: none !important;
  }
}

/**
 * Show element at sm breakpoint 
 */
@media all and (max-width: 23.4375rem) {
  .cat-u-show-sm {
    display: none !important;
  }
}

/**
 * Show element at sm-2 breakpoint 
 */
@media all and (max-width: 35rem) {
  .cat-u-show-sm-2 {
    display: none !important;
  }
}

/**
 * Show element at md breakpoint 
 */
@media all and (max-width: 48rem) {
  .cat-u-show-md {
    display: none !important;
  }
}

/**
 * Show element at lg breakpoint 
 */
@media all and (max-width: 60rem) {
  .cat-u-show-lg {
    display: none !important;
  }
}

/**
 * Show element at xl breakpoint 
 */
@media all and (max-width: 75rem) {
  .cat-u-show-xl {
    display: none !important;
  }
}

/* ------------------------------------*\
    #RESET
\*------------------------------------ */
/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:focus-visible {
  outline-color: var(--cat-theme-color-focus-ring);
}

/* ------------------------------------*\
 #IMAGE-GALLERY-THUMBNAIL
\*------------------------------------ */
/**
 * 1) Image gallery-thumbnail
 */
.cat-c-image-gallery-thumbnail {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex: 1 0 0;
  list-style: none;
  margin: 0;
  padding: var(--cat-space-3x-small);
  /**
  * Add margin right to slotted gallery-thumbnail item
  */
  /**
  * Align gallery-thumbnail items horizontally 
  */
  /*
  * Adding the scroll to custom gallery mobile view
  */
}
.cat-c-image-gallery-thumbnail ::slotted(cat-image-gallery-thumbnail-item) {
  margin-inline-end: var(--cat-space-x-small);
  margin-block-end: var(--cat-space-medium);
  border-radius: calc(var(--size-base-unit) * 1);
  display: block;
}
.cat-c-image-gallery-thumbnail ::slotted(cat-image-gallery-thumbnail-item:focus[tabindex="0"]) {
  outline: 2px solid var(--cat-theme-color-focus-ring);
  outline-offset: var(--cat-theme-offset-focus-ring, 2px);
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
}
.cat-c-image-gallery-thumbnail.cat-c-image-gallery-thumbnail--vertical {
  display: block;
  overflow: hidden auto;
}
.cat-c-image-gallery-thumbnail:not(.cat-c-image-gallery-thumbnail--vertical) {
  flex: 1 0 var(--cat-c-image-gallery__flex-basis, 0);
  overflow-x: var(--cat-c-image-gallery-thumbnail-overflow, auto);
}

.cat-c-image-gallery-thumbnail.cat-c-small ::slotted(cat-image-gallery-thumbnail-item) {
  border-radius: 0;
}
`;
       